<!-- eslint-disable vue/multi-word-component-names -->
<script>
  import AppBox from '@/components/app/box.vue';
  import AppTitledBox from '@/components/app/titledBox.vue';
  import AppConversation from '@/components/app/conversation.vue';
  import AppTitleHeader from '@/components/app/TitleHeader.vue';
  export default {
    components: {
      AppBox,
      AppTitledBox,
      AppConversation,
      AppTitleHeader,
    },
    props: {
      observationDate: {
        type: String,
        default: '-',
      },
      // painScale:{
      //     type:Number,
      //     required:false,
      //     default:0
      // },
      // gapIndexScore:{
      //     type:Number,
      //     required:false,
      //     default:0
      // },
      // temperature:{
      //     type:Number,
      //     required:false,
      //     default:0
      // },
      // gcs:{
      //     type:Number,
      //     required:false,
      //     default:0
      // },
      // bloodSugar:{
      //     type:Number,
      //     required:false,
      //     default:0
      // },
      // spO2:{
      //     type:Number,
      //     required:false,
      //     default:0
      // },
      // pulseRate:{
      //     type:Number,
      //     required:false,
      //     default:0
      // },
      // respiratoryRate:{
      //     type:Number,
      //     required:false,
      //     default:0
      // },
      // diastolicBloodPressure:{
      //     type:Number,
      //     required:false,
      //     default:0
      // },
      // systolicBloodPressure:{
      //     type:Number,
      //     required:false,
      //     default:0
      // },
      signs: {
        type: Array,
        default: () => [],
      },
      actions: {
        type: Object,
        default: () => {
          return {
            drugs: {
              type: Array,
              default: () => [],
            },
            general: {
              type: Array,
              default: () => [],
            },
          };
        },
      },
    },
    computed: {
      afterTechnicianArrivalActions: function () {
        return [...this.actions.general]?.filter(
          ({ isAfterTechnicianArrival }) => !!isAfterTechnicianArrival,
        );
      },
      beforeTechnicianArrivalActions: function () {
        return [...this.actions.general]?.filter(
          ({ isAfterTechnicianArrival }) => !isAfterTechnicianArrival,
        );
      },
    },
  };
</script>
<template>
  <v-row no-gutters class="pa-4">
    <v-col cols="12">
      <app-title-header title="علائم حیاتی" class="mb-4" />
      <app-box outlined max-height="245px" class="flex-gap-4 flex-col">
        <app-titled-box
          v-for="{
            id,
            observationDate,
            painScale,
            gapIndexScore,
            temperature,
            gcs,
            bloodSugar,
            spO2,
            pulseRate,
            respiratoryRate,
            diastolicBloodPressure,
            systolicBloodPressure,
          } in signs"
          :key="id"
          :title="`اولیه (${observationDate})`"
          has-bg
          class="titled-box"
        >
          <v-row class="pa-2">
            <v-col cols="2">
              <app-conversation question="نمره درد" :answer="painScale" />
            </v-col>
            <v-col cols="2">
              <app-conversation question="شاخص GAP" :answer="gapIndexScore" />
            </v-col>
            <v-col cols="2">
              <app-conversation question="TEMP" :answer="temperature" />
            </v-col>
            <v-col cols="2">
              <app-conversation question="GCS" :answer="gcs" />
            </v-col>
            <v-col cols="2">
              <app-conversation question="BS" :answer="bloodSugar" />
            </v-col>
            <v-col cols="2">
              <app-conversation question="SPO2" :answer="spO2" />
            </v-col>
            <v-col cols="2">
              <app-conversation question="PR" :answer="pulseRate" />
            </v-col>
            <v-col cols="2">
              <app-conversation question="RR" :answer="respiratoryRate" />
            </v-col>
            <v-col cols="2">
              <app-conversation question="DBP" :answer="diastolicBloodPressure" />
            </v-col>
            <v-col cols="2">
              <app-conversation question="SBP" :answer="systolicBloodPressure" />
            </v-col>
          </v-row>
        </app-titled-box>
      </app-box>
    </v-col>
    <v-col cols="12" class="mt-4">
      <v-row>
        <v-col cols="6">
          <app-title-header title="اقدامات درمانی" class="mb-4" />
          <app-box outlined max-height="250px">
            <v-row no-gutters>
              <v-col no-gutters class="">
                <app-box
                  class="flex-auto text-center flex-grow mb-2 py-1 rounded-l-0 title-seperator-border"
                >
                  قبل
                </app-box>
                <div class="item-seperator-border">
                  <v-chip-group column>
                    <v-chip
                      color="all-chip"
                      label
                      v-for="{ id, title } in beforeTechnicianArrivalActions"
                      :key="id"
                    >
                      {{ title }}
                    </v-chip>
                  </v-chip-group>
                </div>
              </v-col>
              <v-col>
                <app-box class="flex-auto text-center flex-grow mb-2 py-1 rounded-r-0">بعد</app-box>
                <div>
                  <v-chip-group column>
                    <v-chip
                      label
                      class="all-chip"
                      v-for="{ id, title } in afterTechnicianArrivalActions"
                      :key="id"
                    >
                      {{ title }}
                    </v-chip>
                  </v-chip-group>
                </div>
              </v-col>
            </v-row>
          </app-box>
        </v-col>
        <v-col cols="6">
          <app-title-header title="اقدامات دارویی" class="mb-4" />
          <app-box outlined max-height="286px">
            <v-expansion-panels accordion class="flex-grow-2 flex-col">
              <v-expansion-panel
                v-for="{ id, drugTitle, drugGroupTitle, dosage, actionDate } in actions.drugs"
                :key="id"
                class="drugs-actions-item"
              >
                <v-expansion-panel-header color="light-color">
                  <div class="collaps-title-container flex-gap-1">
                    <div class="drug-title flex-gap-1">
                      {{ drugTitle }}
                    </div>
                    <div class="drug-group-title">({{ drugGroupTitle }} )</div>
                  </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content class="drugs-action-collaps-content">
                  <v-row no-gutters class="mt-3">
                    <v-col class="pl-2">
                      <app-conversation question="دوز" :answer="dosage" />
                    </v-col>
                    <v-col>
                      <app-conversation question="زمان" :answer="actionDate" />
                    </v-col>
                  </v-row>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </app-box>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>
<style lang="scss">
  .drugs-actions-item {
    background-color: var(--background-color) !important;
    border-radius: 6px !important;
  }
  .drugs-action-collaps-content {
    border-top: 1px solid #21212133;
    .v-expansion-panel-content__wrap {
      padding-bottom: 0 !important;
    }
  }
</style>
<style lang="scss" scoped>
  .title-seperator-border {
    border-left: 2px solid #21212133;
  }
  .item-seperator-border {
    border-left: 1px solid var(--dark-color);
  }
  .titled-box {
    border: 1px solid var(--dark-color);
  }
  .collaps-title-container {
    .drug-title {
      font-weight: 600;
    }
    .drug-group-title {
      font-size: 12px;
    }
  }
</style>
